import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Radio,
  Grid,
  Input,
  Dropdown as DropdownNativo,
  Popup,
  Icon,
  Modal
} from 'semantic-ui-react';
import { Field, FormikProps } from 'formik';
import SectionLabel from '../../../../../../components/SectionLabel';
import { FieldLabel } from '../../../../../../styles';
import { CreateClaimEstateInitialInitialValuesType } from '../../Formik/types/CreateClaimEstateInitialValuesTypes';
import { InsurerState } from '../../../../../../types/InsurerState';
import { CustoDropDownItemProps } from '../../../../../../components/types';
import CustomDatePicker from '../../../../../../components/CustomDatePicker';
import {
  DATE_INPUT_MASK,
  maskCpfOrCnpj,
  maskPhoneNumber,
  maskZipCode
} from '../../../../../../services/masks';
import { AddressService } from '../../../../../../services/address';
import FormatedTextArea from '../../../../../../components/FormatedTextArea';
import { ClaimPropertyStatusEnum } from '../../../../../../enums/claim-property-status.enum';
import { getDataByDocument } from '../../../../../../services/documents';
import AppMaskedInput from '../../../../../../components/MaskedInput';
import { getClaimByPolicyNumber } from '../../../../../../services/claim';
import { getClaimEstatesStatusText } from '../../../../constants/ClaimEstatesStatusEnum';
import moment from 'moment-timezone';
import { PushRoute } from '../../../../../../util';
import { useHistory } from 'react-router-dom';
import IconButton from '../../../../../../components/IconButton';
import Button from '../../../../../../components/Button';

import { ActivePolicy } from '../../../../../../services/bond-insurance-policy';

type ClaimEstatesProps = {
  estates: CustoDropDownItemProps[] | null;
  insurers: InsurerState[] | null;
  policy?: ActivePolicy;
  claimAlread?: any | null;
  setClaimAlread: () => void;
  onCloseModal: () => void;
  availableBrokersAndEstates?: any;
};

interface DropdownOptions {
  index: number;
  value: number | string;
  text: string;
}

const ClaimEstateInfoStep = ({
  values,
  insurers,
  estates,
  setFieldValue,
  policy,
  claimAlread,
  setClaimAlread,
  onCloseModal,
  availableBrokersAndEstates
}: FormikProps<CreateClaimEstateInitialInitialValuesType> & ClaimEstatesProps) => {
  const history = useHistory();
  const [loadingZipCode, setLoadingZipCode] = useState(false);
  const [selectableInsurers, setSelectableInsurers] = useState<DropdownOptions[] | any[]>(
    []
  );
  const [selectableEstates, setSelectableEstates] = useState<DropdownOptions[] | any[]>(
    []
  );
  const [loadDocument, setLoadDocument] = useState(false);
  const [disableNameField, setDisabledNameField] = useState<boolean>(true);
  const [loadPolicyNumber, setLoadPolicyNumber] = useState<boolean>(false);
  const [disablePolicyNumber, setDisablePolicyNumber] = useState<boolean>(false);
  const [openModalInfo, setOpenModalInfo] = useState<boolean>(false);
  const [claimAlreadyRegistered, setClaimAlreadyRegistered] = useState<any>();

  useEffect(() => {
    if (values.claimTenant.document) {
      if (!values.claimTenant.fullName) {
        getTenantByDocument(values.claimTenant.document);
      } else {
        setDisabledNameField(false);
      }
    }
  }, []);

  useEffect(() => {
    if (policy) {
      const bondInsuranceAny = policy?.bondInsurance as any;
      const naturalTenant =
        bondInsuranceAny?.naturalTenant || bondInsuranceAny?.natural_tenant;
      const legalTenant = bondInsuranceAny?.legalTenant || bondInsuranceAny?.legal_tenant;
      const estateFromPolicy = bondInsuranceAny?.estate || (policy as any)?.estate;
      const propertyFromPolicy = bondInsuranceAny?.property || (policy as any)?.property;

      // Tenant data
      if (naturalTenant) {
        setFieldValue(
          'claimTenant.cellphone',
          maskPhoneNumber(naturalTenant?.main_tenant_phone || '')
        );
        setFieldValue('claimTenant.fullName', naturalTenant?.main_tenant_name);
        setFieldValue('claimTenant.email', naturalTenant?.main_tenant_email);
        setFieldValue(
          'claimTenant.document',
          maskCpfOrCnpj(naturalTenant?.main_tenant_cpf || (policy as any)?.tenant?.document || '')
        );
      } else if (legalTenant) {
        setFieldValue(
          'claimTenant.cellphone',
          maskPhoneNumber(legalTenant?.phone || '')
        );
        setFieldValue('claimTenant.fullName', legalTenant?.company);
        setFieldValue('claimTenant.email', legalTenant?.email);
        setFieldValue(
          'claimTenant.document',
          maskCpfOrCnpj(legalTenant?.document || (policy as any)?.tenant?.document || '')
        );
      } else {
        setFieldValue('claimTenant.fullName', (policy as any)?.tenant?.name || '');
        setFieldValue(
          'claimTenant.document',
          maskCpfOrCnpj((policy as any)?.tenant?.document || '')
        );
      }
      // Estate data
      if (estateFromPolicy?.id) {
        setFieldValue('claimEstate.estateId', estateFromPolicy?.id);
      }
      // Insurer Data
      const insurerIdFromPolicy =
        policy?.insurer?.id ||
        selectableInsurers.find(insurer => insurer.text === policy?.insurer?.name)?.value;
      if (insurerIdFromPolicy) {
        setFieldValue('claimEstate.insurerId', insurerIdFromPolicy);
      }
      setFieldValue('claimEstate.policyNumber', policy?.insurerPolicyId);
      setFieldValue(
        'claimEstate.policyId',
        bondInsuranceAny?.bondInsuranceHiredDataId || (policy as any)?.hiredDataTableId
      );
      // Property
      setFieldValue(
        'claimProperty.zipCode',
        maskZipCode(propertyFromPolicy?.zip_code || '')
      );
      setFieldValue('claimProperty.city', propertyFromPolicy?.city);
      setFieldValue('claimProperty.complement', propertyFromPolicy?.complement);
      setFieldValue('claimProperty.country', propertyFromPolicy?.country);
      setFieldValue('claimProperty.district', propertyFromPolicy?.district);
      setFieldValue('claimProperty.number', propertyFromPolicy?.number);
      setFieldValue('claimProperty.state', propertyFromPolicy?.state);
      setFieldValue('claimProperty.street', propertyFromPolicy?.street);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policy, selectableEstates, selectableInsurers, setFieldValue]);

  useEffect(() => {
    if (insurers && insurers.length) {
      setSelectableInsurers(
        insurers.map(insurer => ({
          index: insurer.id,
          value: insurer.id,
          text: insurer.name
        }))
      );
    }
  }, [insurers]);

  useEffect(() => {
    if (estates && estates.length) {
      setSelectableEstates(
        estates.map(estate => ({
          index: estate.value.id,
          value: estate.value.id,
          text: estate.value.name
        }))
      );

      const activeEstateId =
        availableBrokersAndEstates?.activeEstateId;

      if (estates.length === 1) {
        setFieldValue('claimEstate.estateId', estates[0].value.id);
      } else if (activeEstateId) {
        const activeEstate = estates.find(e => e.value.id === activeEstateId);
        if (activeEstate) {
          setFieldValue('claimEstate.estateId', activeEstate.value.id);
        }
      }
    }
  }, [estates, availableBrokersAndEstates?.activeEstateId]);

  useEffect(() => {
    if (values.claimProperty.zipCode) {
    }
    if (values.claimProperty.zipCode && values.claimProperty.zipCode.length >= 8) {
      onChangeCep(values.claimProperty.zipCode);
    }
  }, [values.claimProperty.zipCode]);

  useEffect(() => {
    if (claimAlread) {
      setClaimAlreadyRegistered(claimAlread);
      setOpenModalInfo(true);
    }
  }, [claimAlread]);

  async function getTenantByDocument(document: string) {
    try {
      setLoadDocument(true);
      const unformatedDoc = document.replace(/\D/g, '');
      const isCPF = unformatedDoc.length === 11;
      const data = await getDataByDocument(unformatedDoc);
      if (isCPF) {
        setFieldValue('claimTenant.fullName', data.name);
      } else {
        setFieldValue('claimTenant.fullName', data.company);
        setFieldValue('claimTenant.cellphone', data.phone);
        setFieldValue('claimTenant.email', data.email);
        setDisabledNameField(false);
      }
    } catch (err) {
      console.log(err);
      setDisabledNameField(false);
    } finally {
      setLoadDocument(false);
    }
  }

  const onChangeCep = (zipCode: string): void => {
    const maskedValue = maskZipCode(zipCode);

    setFieldValue('claimProperty.zipCode', maskedValue);
    if (maskedValue.length >= 9) {
      setLoadingZipCode(true);

      AddressService.getAddressByZipCode(zipCode)
        .then(address => {
          setFieldValue('claimProperty.city', address.city);
          setFieldValue('claimProperty.district', address.district);
          setFieldValue('claimProperty.state', address.state);
          setFieldValue('claimProperty.street', address.street);
          setLoadingZipCode(false);
        })
        .catch(e => {
          console.log('address error:', e);
        });
    }
  };

  const handleBlurPolicyNumber = async (e: any) => {
    try {
      setClaimAlreadyRegistered(null);
      setLoadPolicyNumber(true);
      setDisablePolicyNumber(true);
      const policyNumber = e.currentTarget.value;
      if (!policyNumber) return;
      await getClaimByPolicyNumber(policyNumber.replace(/[^a-zA-Z0-9]/g, ''))
        .then(result => {
          if (!result.data) return;
          setClaimAlreadyRegistered(result.data);
          setOpenModalInfo(true);
          return;
        })
        .catch(err => {
          console.log('error', err);
        });
    } catch (error) {
      console.log('error on handleBlurPolicyNumber:', error);
    } finally {
      setLoadPolicyNumber(false);
      setDisablePolicyNumber(false);
    }
  };

  return (
    <div>
      <SectionLabel text="Informações do locatário" />

      <Grid columns={16}>
        <Grid.Row>
          <Grid.Column width={4}>
            <FieldLabel>CPF/CNPJ do Locatário*</FieldLabel>
            <Field
              value={values.claimTenant.document}
              component={Input}
              loading={loadDocument}
              fluid
              onChange={(_e: any, { value }: { value: string }) => {
                setFieldValue('claimTenant.document', maskCpfOrCnpj(value));
                setDisabledNameField(true);
              }}
              onBlur={(e: any) => {
                getTenantByDocument(e.target.value);
              }}
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Nome do Locatário*</FieldLabel>
            <Field
              value={values.claimTenant.fullName}
              component={Input}
              fluid
              disabled={disableNameField}
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimTenant.fullName', value)
              }
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Email do Locatário*</FieldLabel>
            <Field
              value={values.claimTenant.email}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimTenant.email', value)
              }
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Telefone do Locatário*</FieldLabel>
            <Field
              value={values.claimTenant.cellphone}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimTenant.cellphone', maskPhoneNumber(value))
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <SectionLabel text="Informações do Seguro" />
      <Grid>
        <Grid.Row>
          <Grid.Column width={5}>
            <FieldLabel>
              SEGURADORA / GARANTIDORA:
              <Popup
                content={
                  'Em caso de dúvidas, verifique a cláusula da garantia no contrato de locação.'
                }
                position={'bottom right'}
                trigger={
                  <IconButton
                    name={'info circle'}
                    style={{ cursor: 'help', marginLeft: 5 }}
                  />
                }
              />
            </FieldLabel>
            <div style={{ width: '100%' }}>
              <DropdownNativo
                style={{ width: '100%' }}
                name={`claimEstate.insurerId`}
                value={values?.claimEstate?.insurerId}
                options={selectableInsurers || []}
                placeholder={'Selecionar...'}
                search
                selection
                clearable
                onChange={(e, { value }) => setFieldValue('claimEstate.insurerId', value)}
              />
            </div>
          </Grid.Column>

          {selectableEstates.length > 1 && (
            <Grid.Column width={5}>
              <FieldLabel>IMOBILIÁRIA*:</FieldLabel>
              <div style={{ width: '100%' }}>
                <DropdownNativo
                  style={{ width: '100%' }}
                  name={`claimEstate.estateId`}
                  value={values?.claimEstate?.estateId}
                  options={selectableEstates || []}
                  placeholder={'Selecionar...'}
                  search
                  selection
                  clearable
                  onChange={(e, { value }) =>
                    setFieldValue('claimEstate.estateId', value)
                  }
                />
              </div>
            </Grid.Column>
          )}

          <Grid.Column width={3}>
            <div style={{ paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <Radio
                label="Imóvel Ocupado"
                name="propertyStatus"
                value={ClaimPropertyStatusEnum.occupied}
                checked={values.claimProperty.status === ClaimPropertyStatusEnum.occupied}
                onChange={() =>
                  setFieldValue('claimProperty.status', ClaimPropertyStatusEnum.occupied)
                }
              />
              <Radio
                label="Imóvel Desocupado"
                name="propertyStatus"
                value={ClaimPropertyStatusEnum.vacant}
                checked={values.claimProperty.status === ClaimPropertyStatusEnum.vacant}
                onChange={() =>
                  setFieldValue('claimProperty.status', ClaimPropertyStatusEnum.vacant)
                }
              />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <FieldLabel>Número da Apólice</FieldLabel>
            <Field
              value={values.claimEstate.policyNumber}
              component={Input}
              fluid
              loading={loadPolicyNumber}
              disabled={disablePolicyNumber}
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimEstate.policyNumber', value)
              }
              onBlur={(_e: any) => {
                handleBlurPolicyNumber(_e);
              }}
            />
          </Grid.Column>

          {values.claimProperty.status === ClaimPropertyStatusEnum.vacant && (
            <>
              <Grid.Column width={4}>
                <FieldLabel>DATA DE ENTREGA DAS CHAVES* </FieldLabel>
                <Field
                  name={`claimProperty.deliveryKeysDate`}
                  selected={values.claimProperty.deliveryKeysDate ? new Date(values.claimProperty.deliveryKeysDate) : undefined}
                  component={CustomDatePicker}
                  customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                  dateFormat={'dd/MM/yyyy'}
                  onChange={(date: Date, _e: SyntheticEvent) => {
                    setFieldValue('claimProperty.deliveryKeysDate', date);
                  }}
                />
              </Grid.Column>

              <Grid.Column width={4}>
                <FieldLabel>Será reclamado danos ao imóvel ou a pintura?</FieldLabel>
                <div style={{ paddingTop: '1rem' }}>
                  <Radio
                    style={{ paddingRight: '1rem' }}
                    label="Sim"
                    name="damageControl"
                    checked={values.damageControl}
                    onChange={() => setFieldValue('damageControl', true)}
                  />
                  <Radio
                    label="Não"
                    name="damageControl"
                    checked={!values.damageControl}
                    onChange={() => setFieldValue('damageControl', false)}
                  />
                </div>
              </Grid.Column>
            </>
          )}
        </Grid.Row>
      </Grid>

      <SectionLabel text="Endereço do imóvel" />
      <Grid columns="equal">
        <Grid.Row>
          <Grid.Column width={3}>
            <FieldLabel>CEP*</FieldLabel>
            <Field
              name="claimProperty.zipCode"
              value={values.claimProperty.zipCode}
              loading={loadingZipCode}
              component={Input}
              maxLength={9}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.zipCode', maskZipCode(value))
              }
            />
          </Grid.Column>

          <Grid.Column width={5}>
            <FieldLabel>Logradouro*</FieldLabel>
            <Field
              name="claimProperty.street"
              value={values.claimProperty.street}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.street', value)
              }
            />
          </Grid.Column>

          <Grid.Column width={5}>
            <FieldLabel>Bairro*</FieldLabel>
            <Field
              name="claimProperty.district"
              value={values.claimProperty.district}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.district', value)
              }
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={5}>
            <FieldLabel>Cidade*</FieldLabel>
            <Field
              name="city"
              value={values.claimProperty.city}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.city', value)
              }
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <FieldLabel>UF*</FieldLabel>
            <Field
              name="values.claimProperty.state"
              value={values.claimProperty.state}
              component={Input}
              fluid
              maxLength={2}
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.state', value)
              }
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <FieldLabel>Número*</FieldLabel>
            <Field
              name="values.claimProperty.number"
              value={values.claimProperty.number}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.number', value)
              }
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <FieldLabel>Complemento</FieldLabel>
            <Field
              name="values.claimProperty.complement"
              value={values.claimProperty.complement}
              component={Input}
              fluid
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimProperty.complement', value)
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <SectionLabel text="Informe os e-mails para receberem notificações do sinistro:" />
      <Grid columns="16" style={{ paddingLeft: '1em' }}>
        {(values.claimEstate?.notificationEmails as string[]).map(
          (notificationEmail, index) => {
            return (
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    value={notificationEmail}
                    component={Input}
                    fluid
                    onChange={(e: any, { value }: { value: string }) => {
                      setFieldValue(`claimEstate.notificationEmails[${index}]`, value);
                    }}
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <Icon
                    name={'remove circle'}
                    color={'grey'}
                    style={{ cursor: 'pointer', paddingTop: '5px' }}
                    size={'large'}
                    onClick={() => {
                      if (values.claimEstate.notificationEmails?.length === 1) {
                        setFieldValue(`claimEstate.notificationEmails`, ['']);
                      } else {
                        const arr1 = values.claimEstate.notificationEmails?.slice(
                          0,
                          index
                        );
                        const arr2 = values.claimEstate.notificationEmails?.slice(
                          index + 1
                        );
                        const newArr = [...(arr1 as string[]), ...(arr2 as string[])];
                        setFieldValue(`claimEstate.notificationEmails`, newArr);
                      }
                    }}
                  />
                </Grid.Column>
                {index + 1 === values.claimEstate.notificationEmails?.length && (
                  <Grid.Column width={5}>
                    <Button
                      onClick={() => {
                        if (values.claimEstate.notificationEmails?.length) {
                          const lastEmail =
                            values.claimEstate.notificationEmails[
                            values.claimEstate.notificationEmails.length - 1
                            ];
                          if (lastEmail.length > 0)
                            setFieldValue(`claimEstate.notificationEmails`, [
                              ...(values.claimEstate.notificationEmails as string[]),
                              ''
                            ]);
                        } else {
                          setFieldValue(
                            `claimEstate.notificationEmails[${index + 1}]`,
                            ''
                          );
                        }
                      }}
                    >
                      <Icon name={'plus circle'} />
                      Adicionar E-mail
                    </Button>
                  </Grid.Column>
                )}
              </Grid.Row>
            );
          }
        )}
      </Grid>
      <SectionLabel text="Observações" />
      <Grid columns="16" style={{ paddingLeft: '1em' }}>
        <Grid.Row>
          <Grid.Column width={16}>
            <Field
              name={`claimEstate.observations`}
              rows={3}
              value={values.claimEstate.observations}
              onChange={(_: SyntheticEvent, data: any) => {
                setFieldValue(`claimEstate.observations`, data.value);
              }}
              component={FormatedTextArea}
              fluid
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Modal
        onClose={() => {
          setOpenModalInfo(false);
          setClaimAlread();
        }}
        onOpen={() => { }}
        open={openModalInfo}
        size={'large'}
        style={{ zIndex: 1001 }}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Este imóvel já possui Sinistro em andamento</Modal.Header>
        <Modal.Content scrolling>
          <div style={{ fontSize: 16 }}>
            Verifique os detalhes e finalize o processo já existente no imóvel antes de
            iniciar um novo Sinistro.
          </div>

          <div
            style={{
              flex: 1,
              padding: 10,
              border: '1px solid #ccc',
              borderWidth: 0.5,
              borderRadius: 6,
              marginTop: 20,
              marginBottom: 5
            }}
          >
            <div style={{ display: 'flex', flex: 1, gap: 20 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  gap: 20
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>Endereço</span>
                  <span style={{ flex: 1, fontSize: 16 }}>
                    {claimAlreadyRegistered?.claimProperty?.street},{' '}
                    {claimAlreadyRegistered?.claimProperty?.number},{' '}
                    {claimAlreadyRegistered?.claimProperty?.district},{' '}
                    {claimAlreadyRegistered?.claimProperty?.city}
                    {'-'}
                    {claimAlreadyRegistered?.claimProperty?.state}
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    justifyContent: 'space-between',
                    gap: 20
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                      Data de solicitação
                    </span>
                    <span style={{ flex: 1, fontSize: 16 }}>
                      {moment(claimAlreadyRegistered?.createdAt)
                        .subtract(3, 'h')
                        .format('DD/MM/YYYY HH:mm:ss')}
                    </span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Inquilino</span>
                    <span style={{ flex: 1, fontSize: 16 }}>
                      {claimAlreadyRegistered?.claimTenant?.fullName
                        ? claimAlreadyRegistered?.claimTenant?.fullName
                        : '-'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Seguradora</span>
                    <span style={{ flex: 1, fontSize: 16 }}>
                      {claimAlreadyRegistered?.insurer?.name
                        ? claimAlreadyRegistered?.insurer?.name
                        : '-'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Imobiliária</span>
                    <span style={{ flex: 1, fontSize: 16 }}>
                      {claimAlreadyRegistered?.estate?.name
                        ? claimAlreadyRegistered?.estate?.name
                        : '-'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: 16, fontWeight: 'bold' }}>Status</span>
                    <span style={{ flex: 1, fontSize: 16 }}>
                      {claimAlreadyRegistered?.status
                        ? getClaimEstatesStatusText(claimAlreadyRegistered?.status)
                        : '-'}
                    </span>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  type="button"
                  color="blue"
                  onClick={() => {
                    const claimId = claimAlreadyRegistered?.id;
                    setOpenModalInfo(false);
                    setClaimAlread();
                    onCloseModal();
                    // Pequeno delay para garantir que as modais fechem antes de navegar
                    setTimeout(() => {
                      PushRoute(history, {}, 'claim_estates', {
                        claimId
                      });
                    }, 100);
                  }}
                >
                  <Icon name="arrow right" /> Acessar Sinistro
                </Button>
              </div>
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Grid>
            <Grid.Column width={16}>
              <Button
                onClick={() => {
                  setOpenModalInfo(false);
                  setClaimAlread();
                }}
                type="button"
                color="grey"
              >
                Fechar
              </Button>
            </Grid.Column>
          </Grid>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ClaimEstateInfoStep;
